export default function SVILoading() {
    return (
        <div className="d-flex justify-content-center m-5 p-5">
            <i className={"fa fa-spinner fa-spin fa-fw fa-4x"}></i>
        </div>
    )
}